import React from 'react';
import { ZoomInIcon } from 'lucide-react';
import { AssetImage } from './AssetImage';
import type { SiteImage } from '../data/collection';
interface ZoomablePageProps {
  image: SiteImage;
  label: string;
  onOpen: () => void;
  compact?: boolean;
  /** Shared frame ratio (width / height) so mixed page sizes align; defaults to the image's own. */
  frameRatio?: string;
}

/** A whole page (never cropped) that opens in the full-screen viewer on click or tap. */
export function ZoomablePage({
  image,
  label,
  onOpen,
  compact = false,
  frameRatio
}: ZoomablePageProps) {
  return <button type="button" onClick={onOpen} aria-label={`Ampliar: ${label}`} className="group relative block w-full cursor-zoom-in overflow-hidden rounded-[6px] bg-paper shadow-[0_16px_32px_-22px_rgba(52,52,49,0.5)] ring-1 ring-graphite/10 transition-[box-shadow] duration-200 ease-out hover:shadow-[0_22px_40px_-22px_rgba(52,52,49,0.6)] focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40" data-id="element-315" data-mp="1owrc7ljgdw8o">
      <span className="block" style={{
      aspectRatio: frameRatio ?? `${image.width} / ${image.height}`
    }} data-id="element-316" data-mp="3sqk4cj9j83yb">
        <AssetImage image={image} compact={compact} thumb data-id="element-317" data-mp="kewokuj1j0w" />
      </span>
      <span className="absolute bottom-2.5 right-2.5 flex h-9 w-9 items-center justify-center rounded-full bg-paper/95 text-graphite shadow-sm ring-1 ring-graphite/10 transition-colors duration-150 ease-out group-hover:text-coral-ink" data-id="element-318" data-mp="3j07miyt3qovv">
        <ZoomInIcon className="h-4 w-4" aria-hidden data-id="element-319" data-mp="38zymf9vzojb7" />
      </span>
    </button>;
}